module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v("临时项目与永久项目的区别")])]), _vm._v(" "), _c('ul', {
    staticClass: "features"
  }, [_c('li', [_c('div', {
    staticClass: "img clock"
  }), _vm._v(" 8小时无阅读限制\n    ")]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "img redpack"
  }), _vm._v(" 过期后读者只能预览部分内容，完整浏览需支付 1 元\n    ")]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "img gold"
  }), _vm._v(" 可通过购买会员套餐或者项目额度来解除限制\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('p', [_vm._v("PP匠一直坚持"), _c('em', [_vm._v("不限制")]), _vm._v("免费用户上传项目的数量，所有的项目链接都是"), _c('em', [_vm._v("永久有效")]), _vm._v("，为此支付了巨额的服务器和流量费用。")]), _vm._v(" "), _c('p', [_vm._v("为了平台长久发展和带来更好的服务，PP匠针对免费用户推出了临时项目的概念，这部分项目在过期后，需要读者付费打赏才能完整浏览。")]), _vm._v(" "), _c('p', [_vm._v("临时项目只适合个人用户用来做短时间非正式分享，如果是正式场合、商用或者是企业用户，"), _c('em', [_vm._v("建议购买合适的会员套餐")]), _vm._v("，以获得最佳的阅读体验和客户服务。")])]), _vm._v(" "), _c('div', {
    staticClass: "example"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/faq-permanents-example.jpg"
    }
  }), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "text-btn",
    attrs: {
      "href": "http://h5.ppj.io/dBdSoWJo/index.html?v=3",
      "target": "_blank"
    }
  }, [_vm._v("查看临时项目案例")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-023b063c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/faq/permanents.vue
// module id = 891
// module chunks = 3